import React, { useState, useEffect, useContext, useCallback } from 'react';
import { Container, Navbar, Nav, Badge } from 'react-bootstrap';
import { NavLink, Link } from 'react-router-dom';
import { client as publicClientApplication, signOut } from '../utilities/AuthUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faCog, faSignOut } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import { useIdentifyEnvironment } from '../hooks/useIdentifyEnvironment';
import NotifierContext from './Contexts/NotifierContext';
import ConnectionStatus from './ConnectionStatus';
import SiteSelector from './SiteSelector';
import PrivilegesContext from './Contexts/PrivilegesContext';

import logo from '../images/cmn-exxonmobil-logo.gif';
import './NavMenu.css';


function NavMenu() {

    const [newJobs, setNewJobs] = useState(0);
    const [newActiveTasks, setNewActiveTasks] = useState(0);

    const account = publicClientApplication.getAllAccounts()[0];
    const environment = useIdentifyEnvironment();
    const location = useLocation();
    const { admin } = useContext(PrivilegesContext);
    const notifier = useContext(NotifierContext);

    const newJob = useCallback(() => {
        if (location.pathname !== "/" && location.pathname !== "/jobs") {
            var newCount = newJobs + 1;
            setNewJobs(newCount);
        }
    }, [location.pathname, newJobs]);

    useEffect(() => {
        notifier.on("jobUpdate", newJob);

        return function () {
            notifier.off("jobUpdate", newJob);
        }
    }, [location, newJob, newJobs, notifier]);

    useEffect(() => {
        if (newJobs > 0 && location.pathname === "/jobs")
            setNewJobs(0);

        if (newActiveTasks > 0 && location.pathname === "/active-tasks")
            setNewActiveTasks(0);
    }, [location, newActiveTasks, newJobs]);

    return (
        <header>
            <Navbar expand="lg" bg="white" variant="light" className="border-bottom box-shadow mb-3">
                <Container fluid>
                    <Navbar.Brand as={Link} to="/">
                        <img src={logo}
                            alt="ExxonMobil logo"
                            className="align-middle me-3 w-50 w-md-25" />
                        <strong>OMDGo! {environment && environment !== "Production" && `(${environment})`}</strong>
                    </Navbar.Brand>

                    <Navbar.Toggle className="ms-auto" />

                    <Navbar.Collapse>
                        <Nav>
                            <Nav.Link as={NavLink} to="/jobs">
                                <Navbar.Text className="text-dark">Jobs</Navbar.Text>
                                {newJobs > 0 && <Badge pill bg="danger">{newJobs}</Badge>}
                            </Nav.Link>
                            <Nav.Link as={NavLink} to="/active-tasks">
                                <Navbar.Text className="text-dark">Active Tasks</Navbar.Text>
                                {newActiveTasks > 0 && <Badge pill bg="danger">{newActiveTasks}</Badge>}
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>

                    <div className="d-flex justify-content-end">
                        <Navbar.Collapse>
                            <Nav>
                                <div className="d-flex align-items-center">
                                    <SiteSelector />
                                </div>
                                {admin &&
                                    <Nav.Link as={NavLink} to="config">
                                        <FontAwesomeIcon icon={faCog} className="me-2 nav-icon" />
                                        <Navbar.Text className="text-dark d-lg-none d-xl-inline">Configuration</Navbar.Text>
                                    </Nav.Link>
                                }
                                <Navbar.Text className="d-lg-none d-xl-inline">
                                    <FontAwesomeIcon icon={faUser} className="me-2 nav-icon" />
                                    <Navbar.Text className="text-dark">{account && account.name}</Navbar.Text>
                                </Navbar.Text>
                                <Nav.Link onClick={signOut}>
                                    <FontAwesomeIcon icon={faSignOut} className="me-2 nav-icon" />
                                    <Navbar.Text className="text-dark d-lg-none d-xl-inline">Sign Out</Navbar.Text>
                                </Nav.Link>
                            </Nav>
                        </Navbar.Collapse>
                    </div>
                    <Nav.Item>
                        <ConnectionStatus className="ms-2" />
                    </Nav.Item>
                </Container>
            </Navbar>
        </header >
    );
}

export default NavMenu;